import { Box, Flex, Img, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import icon from "Assets/location.svg";
import recruiter from "Assets/studentlogo.svg";
import { Link, useNavigate } from "react-router-dom";
import style from "./login.module.css";
export const CommonSignup = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState("");

  const navigateTo = (path) => {
    if (active === "recruiter") {
      navigate("/hiring/recruiter/signup");
    }
    if (active === "student") {
      navigate("/hiring/student/signup");
    }
  };

  return (
    <Box className={style.containerSignup}>
      <div
        className={style.headingContainer}
        style={{
          marginBottom: "0rem",
        }}
      >
        {/* <h1>Namaskaram!</h1> */}
        <img src={recruiter} alt="recruiterlogo" />
        <div className={style.namaskaram}>Namaskaram!</div>
        <div className={style.welcome}>Welcome Back</div>
      </div>
      <Flex>
        <Text mb={4} fontSize={24} fontWeight={500} fontFamily={"Roboto"}>
          Signup
        </Text>
      </Flex>
      <Box className={style.containerSignupWrapper}>
        <Flex
          onClick={() => setActive("recruiter")}
          className={active === "recruiter" ? style.recruiterActive : ""}
        >
          {/* <Img src={icon} /> */}
          <p className="heading"> As Recruiter</p>
        </Flex>
        <Flex
          onClick={() => setActive("student")}
          className={active === "student" ? style.studentActive : ""}
        >
          {/* <Img src={icon} /> */}
          <p className="heading"> As Student</p>
        </Flex>
      </Box>
      <Box className={style.containerSignupButton}>
        <button
          disabled={!active}
          style={{
            cursor: active ? "pointer" : "not-allowed",
          }}
          onClick={() => navigateTo()}
        >
          Signup
        </button>
      </Box>
      <div
        className={style.already}
        style={{
          marginTop: "1rem",
        }}
      >
        <div>
          Already a member?{" "}
          <Link
            to="/"
            style={{ textDecoration: "underline", fontWeight: "600" }}
          >
            Login
          </Link>
        </div>
      </div>
    </Box>
  );
};
